import type { UseMutationResult } from "@tanstack/react-query";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { confidenceCheckerAdminKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

async function removeTeam(teamId: number): Promise<void> {
  await apiClient
    .url(`/confidence-checker-admin/teams/${teamId}`)
    .delete()
    .res();
}

export function useRemoveConfidenceCheckerTeam(): UseMutationResult<
  void,
  Error,
  number
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: removeTeam,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: confidenceCheckerAdminKeys.all,
      });
    },
  });
}
